import { render, staticRenderFns } from "./ProfileVitalSignBodyMass.vue?vue&type=template&id=4e415b57&"
import script from "./ProfileVitalSignBodyMass.vue?vue&type=script&lang=js&"
export * from "./ProfileVitalSignBodyMass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports